module.exports = __webpack_public_path__ + "static/media/slider1.99161a4a.jpg";